import { FC, useMemo } from 'react'

import { Nullable } from 'cng-common/models/utils'

import styles from './PartnerContactRoles.module.scss'

interface IPartnerContactRolesProps {
  role?: Nullable<string>
}

export const PartnerContactRoles: FC<IPartnerContactRolesProps> = ({ role }) => {
  const roles = useMemo(() => {
    if (!role) {
      return ['-']
    }

    return role.split(', ')
  }, [role])

  return (
    <div className={styles.roles}>
      {roles.map((role) => (
        <span key={role} className={styles.role}>
          {role}
        </span>
      ))}
    </div>
  )
}
